export function setRecentContacts(contact, loggedInUserId) {
  const maxRecentContacts = 10;
  const localStorageKey = `${loggedInUserId}-recentContacts`;
  const localStorageValue = JSON.parse(
    localStorage.getItem(localStorageKey) || '[]'
  );
  const {id, name: contactName, display_name} = contact
  const name = display_name || contactName
  const filteredContacts = localStorageValue.filter(c => c.id !== id);
  localStorage.setItem(
    localStorageKey,
    JSON.stringify(
      [{ id, name }, ...filteredContacts].filter(
        (c, idx) => idx < maxRecentContacts
      )
    )
  );
}

export function archiveContactFromLocalStorage(contactToRemove, loggedInUserId) {
  const localStorageKey = `${loggedInUserId}-recentContacts`
  const localStorageValue = JSON.parse(
    localStorage.getItem(localStorageKey) || '[]'
  )

  localStorage.setItem(
    localStorageKey,
    JSON.stringify(
      localStorageValue.filter(c => c.id !== contactToRemove)
    )
  )
}
